export enum HttpConstants {
    Get = 'GET',
    Post = 'POST',
    Put = 'PUT',
    Delete = 'DELETE',
    AuthorizationTag = 'Authorization',
    BearerTokenHeader = 'Bearer ',
    Patch = 'PATCH',
    ContentTypeHeader = 'Content-type',
    ContentTypeValue = 'application/json',
    PreferTag = 'Prefer',
    XAnchorMailbox = 'X-AnchorMailbox',
    PreferValueExchangeBehaviorTag = 'exchange.behavior',
    PreferValueGroupMembers = 'GroupMembers',
    PreferValueGroupDetailsExtended = 'GroupDetailsExtended',
    PreferValueUpdateGroup = 'UpdateGroup',
    PreferValueUpdateGroupV2 = 'UpdateGroupV2',
    GenerateRWCToken = 'GenerateReadWriteConsistencyToken',
    RWCTokenResponseHeader = 'ReadWriteConsistencyToken',
    OIDPrefix = 'OID:',
}
